module.exports = __webpack_public_path__ + "media/src/images/certificates/certificate_ects_frame-c75370aba344010c60bbafd991894123.png";